const artistsIT = {
    "view": {
        "table": {
            "title": "La tua lista di artisti",
            "column": {
                "name": "Nome Artista",
                "owner": "Proprietario",
                "spotify_link": "Link Spotify",
                "apple_music_link": "Link Apple Music",
                "amazon_music_link": "Link Amazon Music",
                "deezer_link": "Link Deezer",
                "flagged": "Contrassegnato",
                "blacklisted": "Lista Nera",
                "action": "Azione"
            },
            "button": {
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "message": {
                "artistFlagged": "Questo artista è contrassegnato e il pagamento in escrow è richiesto per distribuire il rilascio su Spotify.",
                "artistNotFlagged": "Questo artista è idoneo per la distribuzione su Spotify.",
                "artistBlacklisted": "Questo artista è sulla lista nera e non idoneo per la distribuzione.",
                "artistNotBlacklisted": "Questo artista non è sulla lista nera e idoneo per la distribuzione.",
            }
        },
        "message": {
            "success": "L'artista è stato rimosso!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!",
            "notSubscribed": "Non sei iscritto a nessun piano, quindi puoi aggiungere solo <strong>3 Artisti</strong>, Per favore <3>iscriviti</3> a un piano per usufruire di un numero illimitato di artisti.",
            "subscriptionUpgrade": "Il tuo piano di abbonamento attuale non supporta questa funzione. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzione.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzione.",
            "noAccess": "Non hai accesso a questo modulo, per favore contatta il team di supporto per ulteriori informazioni."
        },
        "modal": {
            "cantBeDeleted": {
                "header": "L'artista {{artistName}} non può essere eliminato",
                "body": "L'artista {{artistName}} non può essere eliminato poiché ha già Traccia(e)/Rilascio(i) associati a lui."
            },
            "delete": {
                "header": "Eliminare {{artistName}}?",
                "body": "Sei sicuro di voler davvero eliminare questo artista? Questa azione potrebbe scollegare il tuo artista dal rilascio assegnato."
            },
            "edit": {
                "header": "Modificare {{artistName}}?",
                "body": "Sei sicuro di voler cambiare il nome del tuo artista? Questo potrebbe avere un effetto sui metadati del rilascio."
            }
        }
    },
    "add": {
        "title": "Aggiungi Artista",
        "form": {
            "label": {
                "is_new_artist": "È Nuovo Artista",
                "spotify_profile": "Profilo Spotify",
                "deezer_profile": "Profilo Deezer",
                "amazon_music_profile": "Profilo Amazon Music",
                "spotify_image": "Immagine Spotify",
                "deezer_image": "Immagine Deezer",
                "amazon_music_image": "Immagine Amazon Music",
                "spotify_id": "ID Spotify",
                "deezer_id": "ID Deezer",
                "amazon_music_id": "ID Amazon Music",
                "apple_id": "ID Apple",
                "name": "Nome",
                "name_preference": "Preferenza Nome",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "subuser": "Sotto-Utente"
            },
            "help_text": {
                "is_new_artist": "Stai aggiungendo un nuovo artista cioè Se il tuo artista ha rilasci su Spotify/Deezer/Amazon Music/Apple Music seleziona No altrimenti seleziona Sì.",
                "spotify_profile": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un Artista che è già su Spotify altrimenti clicca sul pulsante Non Trovato.",
                "deezer_profile": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un Artista che è già su Deezer altrimenti clicca sul pulsante Non Trovato.",
                "amazon_music_profile": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un Artista che è già su Amazon Music altrimenti clicca sul pulsante Non Trovato.",
                "apple_id": "Nota: Usa questo campo solo se vuoi aggiungere un Artista che è già su Apple Music altrimenti clicca sul pulsante Non Trovato.",
                "subuser": "Nota: Usa questo menu a tendina solo se vuoi Aggiungere Artista per uno dei tuoi Sotto-utenti altrimenti lascia non selezionato."
            },
            "placeholder": {
                "subuser": "Seleziona Sotto-utente...",
                "spotify_profile": "Inserisci Nome Artista cioè The Weekend o ID Spotify dell'Artista cioè 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Inserisci Nome Artista cioè The Weekend o ID Deezer dell'Artista cioè 1406580",
                "amazon_music_profile": "Inserisci Nome Artista cioè The Weekend o ASIN Amazon dell'Artista cioè B005GI0T2U",
                "apple_id": "Per favore inserisci un ID Apple valido. Esempio: 635806095"
            },
            "button": {
                "reset": "Reimposta",
                "not_found": "Non Trovato",
                "submit": "Invia"
            },
            "option": {
                "yes": "Sì",
                "no": "No"
            },
            "validation": {
                "name_required": "Il nome è richiesto",
                "name_invalid": "Il nome dell'artista deve contenere 'DJ' solo in maiuscolo",
                "email_required": "L'email è richiesta",
                "email_invalid": "Per favore inserisci un'email valida",
                "name_duplicate": "L'artista esiste già",
                "name_mismatch": "Il nome dell'artista deve corrispondere per tutti i negozi",
                "spotify_id_invalid": "Per favore aggiungi un ID Spotify valido. Esempio: 6eUKZXaKkcviH0Ku9w2n3B. Controlla il nostro Centro Assistenza per ulteriori informazioni.",
                "apple_id_required": "L'ID Apple è richiesto",
                "apple_id_invalid": "Per favore aggiungi un ID Apple valido. Esempio: 635806095. Controlla il nostro Centro Assistenza per ulteriori informazioni."
            }
        },
        "modal": {
            "title": {
                "new_artist_declaration": "Dichiarazione Nuovo Artista",
                "profile_not_present_declaration": "Dichiarazione Profilo Non Presente"
            },
            "body": {
                "profile_not_present_declaration": "Confermo che il profilo di questo Artista non è presente su <strong>{{store}}</strong> e che il profilo di questo Artista sarà creato ex novo su <strong>{{store}}</strong>.",
                "new_artist_declaration": "Confermo che il profilo di questo Artista non è presente su nessuno dei seguenti negozi e che il profilo di questo Artista sarà creato ex novo su questi negozi.",
                "new_artist_declaration_amazon_music": "Amazon Music",
                "new_artist_declaration_apple_music": "Apple Music",
                "new_artist_declaration_deezer": "Deezer",
                "new_artist_declaration_spotify": "Spotify"
            },
            "button": {
                "confirm": "Conferma",
                "cancel": "Annulla"
            }
        },
        "message": {
            "success": "L'artista è stato aggiunto!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!",
            "errorBlacklisted": "Una o più delle dettagli che hai fornito sono relativi a un artista che è sulla lista nera. Se sei sicuro che l'artista non sia sulla lista nera, contatta il team di supporto per ulteriori informazioni."
        }
    },
    "update": {
        "title": "Modifica Artista",
        "form": {
            "label": {
                "spotify_profile": "Profilo Spotify",
                "deezer_profile": "Profilo Deezer",
                "amazon_music_profile": "Profilo Amazon Music",
                "spotify_image": "Immagine Spotify",
                "deezer_image": "Immagine Deezer",
                "amazon_music_image": "Immagine Amazon Music",
                "spotify_id": "ID Spotify",
                "deezer_id": "ID Deezer",
                "amazon_music_id": "ID Amazon Music",
                "apple_id": "ID Apple",
                "name": "Nome",
                "name_preference": "Preferenza Nome",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "flagged": "Contrassegnato"
            },
            "help_text": {
                "spotify_profile": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un Artista che è già su Spotify altrimenti clicca sul pulsante Non Trovato.",
                "deezer_profile": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un Artista che è già su Deezer altrimenti clicca sul pulsante Non Trovato.",
                "amazon_music_profile": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un Artista che è già su Amazon Music altrimenti clicca sul pulsante Non Trovato.",
                "apple_id": "Nota: Usa questo campo solo se vuoi aggiungere un Artista che è già su Apple Music altrimenti clicca sul pulsante Non Trovato."
            },
            "placeholder": {
                "spotify_profile": "Inserisci Nome Artista cioè The Weekend o ID Spotify dell'Artista cioè 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Inserisci Nome Artista cioè The Weekend o ID Deezer dell'Artista cioè 1406580",
                "amazon_music_profile": "Inserisci Nome Artista cioè The Weekend o ASIN Amazon dell'Artista cioè B005GI0T2U",
                "apple_id": "Per favore inserisci un ID Apple valido. Esempio: 635806095"
            },
            "button": {
                "reset": "Reimposta",
                "not_found": "Non Trovato",
                "submit": "Invia"
            },
            "validation": {
                "name_required": "Il nome è richiesto",
                "email_required": "L'email è richiesta",
                "email_invalid": "Per favore inserisci un'email valida",
                "name_duplicate": "L'artista esiste già",
                "name_mismatch": "Il nome dell'artista deve corrispondere per tutti i negozi",
                "name_mismatch_spotify": "Il Nome del Profilo Spotify deve corrispondere al Nome dell'Artista",
                "name_mismatch_deezer": "Il Nome del Profilo Deezer deve corrispondere al Nome dell'Artista",
                "name_mismatch_amazon_music": "Il Nome del Profilo Amazon deve corrispondere al Nome dell'Artista",
                "spotify_id_invalid": "Per favore aggiungi un ID Spotify valido. Esempio: 6eUKZXaKkcviH0Ku9w2n3B. Controlla il nostro Centro Assistenza per ulteriori informazioni.",
                "apple_id_required": "L'ID Apple è richiesto",
                "apple_id_invalid": "Per favore aggiungi un ID Apple valido. Esempio: 635806095. Controlla il nostro Centro Assistenza per ulteriori informazioni."
            }
        },
        "modal": {
            "title": {
                "profile_reset_declaration": "Dichiarazione Reset Profilo",
                "profile_not_present_declaration": "Dichiarazione Profilo Non Presente"
            },
            "body": {
                "profile_not_present_declaration": "Confermo che il profilo di questo Artista non è presente su <strong>{{store}}</strong> e che il profilo di questo Artista sarà creato ex novo su <strong>{{store}}</strong>.",
                "profile_reset_declaration": "Sono consapevole che resettando il profilo <strong>{{store}}</strong> di questo Artista verrà rimosso l'<strong>ID {{store}}</strong> da ogni parte del sistema e facendo ciò, è probabile che si verifichino interruzioni nei negozi e che gli artisti non corrispondano."
            },
            "button": {
                "confirm": "Conferma",
                "cancel": "Annulla"
            }
        },
        "message": {
            "success": "L'artista di nome '{{artistName}}' è stato aggiornato!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!",
            "errorBlacklisted": "Una o più delle dettagli che hai fornito sono relativi a un artista che è sulla lista nera. Se sei sicuro che l'artista non sia sulla lista nera, contatta il team di supporto per ulteriori informazioni."
        }
    },
    "add_from_wishlist": {
        "title": "Aggiungi Artista",
        "form": {
            "label": {
                "spotify_profile": "Profilo Spotify",
                "deezer_profile": "Profilo Deezer",
                "amazon_music_profile": "Profilo Amazon Music",
                "spotify_id": "ID Spotify",
                "spotify_image": "Immagine Spotify",
                "deezer_id": "ID Deezer",
                "deezer_image": "Immagine Deezer",
                "amazon_music_id": "ID Amazon",
                "amazon_music_image": "Immagine Amazon Music",
                "apple_id": "ID Apple",
                "apple_image": "Immagine Apple",
                "name": "Nome",
                "name_preference": "Preferenza Nome",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "subuser": "Sotto-Utente"
            },
            "placeholder": {
                "spotify_profile": "Inserisci Nome Artista cioè The Weekend o ID Spotify dell'Artista cioè 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Inserisci Nome Artista cioè The Weekend o ID Deezer dell'Artista cioè 1406580",
                "amazon_music_profile": "Inserisci Nome Artista cioè The Weekend o ASIN Amazon dell'Artista cioè B005GI0T2U",
                "apple_id": "Per favore inserisci un ID Apple valido. Esempio: 635806095",
                "subuser": "Seleziona Sotto-utente..."
            },
            "help_text": {
                "spotify_profile": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un Artista che è già su Spotify altrimenti clicca sul pulsante Non Trovato.",
                "deezer_profile": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un Artista che è già su Deezer altrimenti clicca sul pulsante Non Trovato.",
                "amazon_music_profile": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un Artista che è già su Amazon Music altrimenti clicca sul pulsante Non Trovato.",
                "apple_id": "Nota: Usa questo campo solo se vuoi aggiungere un Artista che è già su Apple Music altrimenti clicca sul pulsante Non Trovato.",
                "subuser": "Nota: Usa questo menu a tendina solo se vuoi Aggiungere Artista per uno dei tuoi Sotto-utenti altrimenti lascia non selezionato."
            },
            "button": {
                "reset": "Reimposta",
                "notFound": "Non Trovato?",
                "submit": "Invia",
                "cancel": "Annulla",
                "confirm": "Conferma"
            },
            "validation": {
                "name_required": "Il nome è richiesto",
                "email_required": "L'email è richiesta",
                "email_invalid": "Per favore inserisci un'email valida",
                "spotify_id_invalid": "Per favore aggiungi un ID Spotify valido. Esempio: 6eUKZXaKkcviH0Ku9w2n3B. Controlla il nostro Centro Assistenza per ulteriori informazioni.",
                "apple_id_required": "L'ID Apple è richiesto",
                "apple_id_invalid": "Per favore aggiungi un ID Apple valido. Esempio: 635806095. Controlla il nostro Centro Assistenza per ulteriori informazioni."
            },
            "message": {
                "errorArtistExists": "L'artista esiste già",
                "errorNameMismatch": "Il nome dell'artista deve corrispondere per tutti i negozi",
                "errorSpotifyNameMismatch": "Il Nome del Profilo Spotify deve corrispondere al Nome dell'Artista",
                "errorDeezerNameMismatch": "Il Nome del Profilo Deezer deve corrispondere al Nome dell'Artista",
                "errorAmazonNameMismatch": "Il Nome del Profilo Amazon deve corrispondere al Nome dell'Artista"
            }
        },
        "message": {
            "success": "L'artista è stato aggiunto!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!",
            "errorBlacklisted": "Una o più delle dettagli che hai fornito sono relativi a un artista che è sulla lista nera. Se sei sicuro che l'artista non sia sulla lista nera, contatta il team di supporto per ulteriori informazioni."
        },
        "modal": {
            "profileMissing": {
                "header": "Dichiarazione Profilo Non Presente",
                "body": "Confermo che il profilo di questo Artista non è presente su <strong>{{storeName}}</strong> e che il profilo di questo Artista sarà creato ex novo su <strong>{{storeName}}</strong>.",
                "button": {
                    "cancel": "Annulla",
                    "confirm": "Conferma"
                }
            }
        }
    },
    "viewDetails": {
        "view": {
            "label": {
                "followers": "SEGUACI",
                "popularity": "POPOLARITÀ",
                "genres": "GENERI",
                "flagged": "CONTRASSEGNATO",
                "notAvailable": "Non Disponibile",
                "notAvailableAbbr": "N/D"
            },
            "similarArtists": {
                "title": "Artisti Simili",
                "table": {
                    "column": {
                        "artist": "Artista",
                        "followers": "Seguaci",
                        "popularity_pct": "Popolarità (%)",
                        "genres": "Generi",
                        "wishlist": "Lista dei Desideri"
                    }
                },
                "label": {
                    "notAvailable": "Non Disponibile",
                    "notAvailableAbbr": "N/D"
                },
                "message": {
                    "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!"
                },
                "modal": {
                    "addToWishlist": {
                        "header": "Aggiungi Artista {{artistName}} alla Lista dei Desideri",
                        "body": "Sei sicuro di voler aggiungere l'artista {{artistName}} alla tua lista dei desideri?",
                        "message": {
                            "success": "Artista aggiunto alla lista dei desideri!"
                        }
                    },
                    "removeFromWishlist": {
                        "header": "Rimuovi Artista {{artistName}} dalla Lista dei Desideri",
                        "body": "Sei sicuro di voler rimuovere l'artista {{artistName}} dalla tua lista dei desideri?"
                    }
                }
            },
            "topTracks": {
                "title": "Tracce Principali",
                "table": {
                    "column": {
                        "track": "Traccia",
                        "release": "Rilascio",
                        "artists": "Artista(i)",
                        "popularity_pct": "Popolarità (%)",
                        "preview": "Anteprima"
                    }
                },
                "label": {
                    "audioElementNotSupported": "Il tuo browser non supporta l'elemento audio."
                }
            }
        }
    }
};

export default artistsIT;